/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { StatusWrapper, StatusText } from "./style";
import { all_status } from "./consts";
import { snakeCaseToTitleCase } from '@applyboard/ui-utils';
var SingleStatus = function SingleStatus(_ref) {
  var className = _ref.className,
    status = _ref.status,
    noLabel = _ref.noLabel,
    onClick = _ref.onClick,
    tooltipMessage = _ref.tooltipMessage,
    tooltipId = _ref.tooltipId;
  var icon = '';
  switch (status) {
    case 'completed':
      icon = 'check';
      break;
    case 'not_approved':
      icon = 'times';
      break;
    case 'no_status':
      icon = 'ban';
      break;
    case 'missing':
      icon = 'exclamation-triangle';
      break;
    case 'reviewing':
      icon = 'hourglass-half';
      break;
    case 'pending_receipt':
      icon = 'exclamation-triangle';
      break;
    case 'pending_verification':
      icon = 'hourglass-half';
      break;
  }
  return /*#__PURE__*/React.createElement(StatusWrapper, {
    status: status,
    onClick: onClick,
    className: className,
    "data-tip": tooltipMessage,
    "data-for": tooltipId
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FontAwesome, {
    name: icon,
    size: "lg"
  })), !noLabel && /*#__PURE__*/React.createElement(StatusText, null, snakeCaseToTitleCase(status)));
};
SingleStatus.propTypes = {
  className: PropTypes.string,
  status: PropTypes.oneOf(all_status).isRequired,
  noLabel: PropTypes.bool
};
SingleStatus.defaultProps = {
  className: undefined,
  noLabel: false
};
export default SingleStatus;